import React, { useState } from 'react'
import InputRange, { Range } from 'react-input-range';

import { NearByNav, CategoriesFilter, MapView, Checkbox } from '../../components'
import { Hotels } from '../hotel/components';

export default () => {
    const [showCategories, setShowCategories] = useState(false)
    const [showMap, setShowMap] = useState(false)
    const [showFilter, setShowFilter] = useState(false)
    const [budget, setBudget] = useState({ max: 350, min: 50 })
    const [distance, setDistance] = useState(500)

    const categoriesToggle = () => setShowCategories(!showCategories)
    const filterToggle = () => setShowFilter(!showFilter)
    const mapToggle = () => setShowMap(!showMap)

    return (
        <div>
            <NearByNav />
            <div className="body-wrapper clearfix p-t0">
                <div className="hotel-wrapper">

                    <div className="filter-wrapper" style={{ display: showFilter ? 'block' : 'none' }}>
                        <div className={`filter-container ${showMap && 'activate-map-view'}`}>
                            <div className="filter-box">
                                <h4 className="filter-box-title">Filters
                                        <a href="/">Reset</a>
                                </h4>
                                <button onClick={filterToggle} className="fr p-r15 close-filter">
                                    <img src="/images/icons/close-icon.png" alt="close" />
                                </button>
                            </div>
                            <div className="filter-box">
                                <h6>Nearby Distance</h6>
                                <InputRange
                                    formatLabel={value => `${value}km`}
                                    value={distance}
                                    onChange={value => setDistance(value as number)}
                                    minValue={0}
                                    maxValue={1000}
                                />
                            </div>
                            <div className="filter-box">
                                <h6>Filter By Budget</h6>
                                <InputRange
                                    formatLabel={value => `$${value}`}
                                    value={budget}
                                    onChange={value => setBudget(value as Range)}
                                    minValue={0}
                                    maxValue={500}
                                />
                            </div>
                            <div className="filter-box">
                                <h6>Filter By Facility</h6>
                                <ul>
                                    <li><Checkbox label="Wifi" /></li>
                                    <li><Checkbox label="Free Breakfast" /></li>
                                    <li><Checkbox label="Welcome Package" /></li>
                                    <li><Checkbox label="Free Parking" /></li>
                                    <li><Checkbox label="Pool" /></li>
                                    <li><Checkbox label="Pet Friendly" /></li>
                                </ul>
                            </div>
                            <div className="filter-box">
                                <h6>Filter by Star Rating</h6>
                                <ul>
                                    <li><Checkbox label={() => <img src="/images/icons/filter-rating-5.png" alt="5" />} onChange={() => console.log('mp')} /></li>
                                    <li><Checkbox label={() => <img src="/images/icons/filter-rating-4.png" alt="4" />} /></li>
                                    <li><Checkbox label={() => <img src="/images/icons/filter-rating-3.png" alt="3" />} /></li>
                                    <li><Checkbox label={() => <img src="/images/icons/filter-rating-2.png" alt="2" />} /></li>
                                    <li><Checkbox label={() => <img src="/images/icons/filter-rating-1.png" alt="1" />} /></li>
                                </ul>
                            </div>
                            <div className="filter-box">
                                <h6>Filter by Accommodation Type</h6>
                                <ul>
                                    <li><Checkbox label="Apartment" /></li>
                                    <li><Checkbox label="Cottages" /></li>
                                    <li><Checkbox label="Guest House" /></li>
                                    <li><Checkbox label="Hotel" /></li>
                                    <li><Checkbox label="Resort" /></li>
                                    <li><Checkbox label="Villa" /></li>
                                </ul>
                            </div>
                        </div>
                    </div>


                    <div className="hotel-body">
                        <div className={'page-header'}>
                            <div className="page-title clearfix">
                                <h4 className="fl">
                                    Near By Hotels<br />
                                    <small>220 Hotels Found</small>
                                </h4>
                                <span className="cta fr filter-button" onClick={filterToggle}>
                                    Filters
                                    </span>
                            </div>
                            <div className="tool-bar">
                                <label className="p-r5">Short by: </label>
                                <select className="small">
                                    <option>Date</option>
                                    <option>Date 1</option>
                                    <option>Date 2</option>
                                </select>

                                <div className="toggle-button">
                                    <button className={`grid ${!showMap ? 'active' : ''}`} onClick={mapToggle}>
                                        Grid
                                        </button>
                                    <button className={`map ${showMap ? 'active' : ''}`} onClick={mapToggle}>
                                        Map
                                        </button>
                                </div>
                                <div className="toggle-button">
                                    <button className={`category ${showCategories === true ? 'active' : ''}`} onClick={categoriesToggle}>
                                        Category
                                        </button>
                                    <button className="location">
                                        Location
                                        </button>
                                </div>
                            </div>
                        </div>
                        <div className="tour-wrapper">
                            <div className={`grid-n-map-view ${showMap && 'map-view'}`}>
                                <Hotels />
                                {showMap && <MapView data={[]}/>}
                            </div>
                            <CategoriesFilter
                                filterShow={showCategories}
                                countryId={1}
                                applyFilter={() => {}}
                                resetFilter={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}